import React, { useState } from 'react';
import { 
  Box,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme
} from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';

export const TextFieldWithPopup = ({ 
  label,
  value,
  onChange,
  rows = 8,
  required = false,
  error = false,
  helperText = '',
  onBlur, // <-- add onBlur prop support
}) => {
  const [open, setOpen] = useState(false);
  const [tempValue, setTempValue] = useState('');
  const theme = useTheme();

  const handleOpen = () => {
    setTempValue(value);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    // Call the original onChange handler with a simulated event
    onChange({ target: { value: tempValue } });
    setOpen(false);
  };

  const handleDialogChange = (e) => {
    setTempValue(e.target.value);
  };

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <TextField
          label={label}
          multiline
          rows={rows}
          fullWidth
          value={value}
          onChange={onChange}
          required={required}
          error={error}
          helperText={helperText}
          InputProps={{
            sx: { pr: 5 } // Leave space for the expand button
          }}
          onBlur={onBlur} // <-- pass onBlur to TextField
        />
        <IconButton 
          onClick={handleOpen}
          size="small"
          sx={{ 
            position: 'absolute', 
            right: 8, 
            top: 8,
            zIndex: 1,
            '&:hover': {
              color: theme.palette.primary.main,
              bgcolor: 'rgba(25, 118, 210, 0.08)'
            }
          }}
          aria-label={`Expand ${label}`}
        >
          <OpenInFullIcon />
        </IconButton>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth

        aria-labelledby="expanded-text-field-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
              height:"100vh"
          }
        }}
      >
        <DialogTitle 
          id="expanded-text-field-dialog-title" 
          sx={{ 
            bgcolor: '#f0f6ff', 
            color: theme.palette.primary.main, 
            fontWeight: 600,
            borderBottom: '1px solid #e0e0e0',
            py: 1.5
          }}
        >
          {label}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: '#757575',
              '&:hover': {
                color: theme.palette.primary.main,
                bgcolor: 'rgba(25, 118, 210, 0.08)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent 
          sx={{
            pb: 0,
            pt: 0,
            px: 2,
            bgcolor: '#f8f9fa'
          }}
        >
          <TextField
            autoFocus
            multiline
            rows={23}
            fullWidth
            value={tempValue}
            onChange={handleDialogChange}
            variant="outlined"
            error={error}
            sx={{
                mt: 1.5,
                '& .MuiOutlinedInput-root': {
                    bgcolor: '#ffffff',

                    padding: '0px 0px',
                },
              '& .MuiOutlinedInput-input': {
                bgcolor: '#ffffff',
                fontSize: '1.5rem',
                height: '73vh !important',
                padding: '10px 10px',
              }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ bgcolor: '#f8f9fa', pb: 1.5, px: 2 }}>
          <Button 
            onClick={handleClose} 
            color="inherit"
            sx={{ textTransform: 'none', fontWeight: 500 }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSave}
            variant="contained"
            color="primary"
            sx={{
              textTransform: 'none',
              px: 3,
              ml: 1,
              fontWeight: 500
            }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
